import {
  Button,
  mediaQueries,
  size,
  colors,
  typography,
} from '@everlywell/leaves';
import styled from 'styled-components';

type PromoWrapperProps = {
  row: number;
  column: number;
  span: number;
};

const PromoWrapper = styled.a<PromoWrapperProps>`
  text-decoration: none;
  grid-row: ${(props) => props.row + 2};

  /* Rows of 2 or more cards - prevent promo on 1st row */
  ${mediaQueries.forTabletVerticalUp} {
    grid-column: ${(props) => (props.column ? props.column : 1)} / span
      ${(props) => props.span};
    grid-row: ${(props) => (props.row > 1 ? props.row : 2)};
  }
`;

const ImageWrapper = styled.div`
  box-shadow: 0 7px 30px -10px #dce4e5;
  border: solid 1px ${colors.teal1};
  border-radius: ${size.xs3}px;

  .gatsby-image-wrapper-constrained {
    display: flex;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: ${size.lg}px;
  text-decoration: none;
  font-size: 20.3px;
  font-family: ${typography.type.nexa};
  font-weight: normal;
  line-height: 1.28;
  letter-spacing: 0.3px;
  color: ${colors.teal6};

  ${mediaQueries.forPhoneOnly} {
    flex-direction: column;
    padding-top: ${size.md}px;
    padding-bottom: 0;
  }
`;

const PromoContent = styled.p<{ isVitamin: boolean }>`
  ${mediaQueries.forPhoneOnly} {
    padding-bottom: ${size.md}px;
    width: auto;
  }

  ${mediaQueries.forTabletVerticalUp} {
    max-width: 65%;
  }

  /* TODO: Get rid of this logic once we end the launch promo, or replace
  with a better Contentful managed way to create styled content.
  One-off hack to meet design requirements from CG-1614 */
  color: ${(props) => props.isVitamin && colors.gray4};

  span {
    color: ${colors.green5};
  }

  em {
    font-weight: ${typography.weight.regular};
  }
`;

const PromoButton = styled(Button)`
  height: 50%;
  ${mediaQueries.forPhoneOnly} {
    width: 55%;
  }
`;

export {
  PromoWrapper,
  ImageWrapper,
  ContentWrapper,
  PromoContent,
  PromoButton,
};
